var _defs, _polygon, _path, _polygon2, _polygon3, _polygon4, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _rect2, _path11, _path12, _polygon5, _path13, _path14, _path15, _rect3, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRhgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4a5257;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.52 29.85 42.52 27.32 40.08 27.32 40.08 29.85 38.76 29.85 38.76 23.54 40.08 23.54 40.08 26.04 42.52 26.04 42.52 23.54 43.84 23.54 43.84 29.85 42.52 29.85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.48,26.69a1.88,1.88,0,0,0-1.82-2,1.86,1.86,0,0,0-1.81,2h0a1.88,1.88,0,0,0,1.83,2,1.85,1.85,0,0,0,1.8-2ZM51.66,30a3.15,3.15,0,0,1-3.19-3.24v0a3.2,3.2,0,1,1,6.39,0h0A3.18,3.18,0,0,1,51.66,30"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.95 24.82 61.95 29.85 60.63 29.85 60.63 24.82 58.8 24.82 58.8 23.54 63.78 23.54 63.78 24.82 61.95 24.82"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.74 29.85 68.74 23.54 73.27 23.54 73.27 24.78 70.05 24.78 70.05 26.06 72.89 26.06 72.89 27.29 70.05 27.29 70.05 28.61 73.32 28.61 73.32 29.85 68.74 29.85"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "78.43 29.85 78.43 23.54 79.76 23.54 79.76 28.59 82.75 28.59 82.75 29.85 78.43 29.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.12,30A3.08,3.08,0,0,1,93,26.71v0a3.15,3.15,0,0,1,3.15-3.25,3.21,3.21,0,0,1,2.37.86l-.84,1.05a2.16,2.16,0,0,0-1.57-.64,1.87,1.87,0,0,0-1.73,2h0a1.85,1.85,0,0,0,1.83,2,2,2,0,0,0,1.24-.37v-.9H96.08v-1.2h2.61V29a3.81,3.81,0,0,1-2.57,1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.82,25.7c0-.6-.39-.9-1-.9h-1.32v1.8h1.34c.65,0,1-.36,1-.89Zm0,4.15-1.29-2h-1v2h-1.32V23.54h2.75a2,2,0,0,1,2.26,2.08v0a2,2,0,0,1-1.28,2l1.47,2.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.8,26.69a1.88,1.88,0,0,0-1.82-2,1.86,1.86,0,0,0-1.81,2h0a1.88,1.88,0,0,0,1.82,2,1.86,1.86,0,0,0,1.81-2ZM117,30a3.15,3.15,0,0,1-3.19-3.24v0a3.2,3.2,0,1,1,6.39,0h0A3.18,3.18,0,0,1,117,30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.56,29.94c-1.62,0-2.6-.94-2.6-2.79V23.54h1.32v3.57c0,1,.49,1.56,1.3,1.56s1.29-.52,1.29-1.52V23.54h1.33V27.1c0,1.91-1,2.84-2.64,2.84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.66,25.75c0-.62-.41-.95-1.07-.95h-1v1.92h1.05a1,1,0,0,0,1-.95ZM137.57,28h-1v1.89h-1.32V23.54h2.46a2.11,2.11,0,0,1,2.3,2.18v0A2.19,2.19,0,0,1,137.57,28"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.76,
    y: 20,
    width: 100.96,
    height: 0.39
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.24,2.13l-6.13,14.7H53.9l1.4-3.45h6.24l1.38,3.45h2.87L59.66,2.13Zm3.3,8.72H56.3l2.11-5.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.49,2.23H67.26v14.6h5.23a7.12,7.12,0,0,0,7.4-7.32A7.1,7.1,0,0,0,72.49,2.23Zm4.58,7.32a4.39,4.39,0,0,1-4.58,4.69H70V4.83h2.53A4.45,4.45,0,0,1,77.07,9.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.15,2a7.27,7.27,0,0,0-7.3,7.56,7.29,7.29,0,1,0,14.57,0A7.24,7.24,0,0,0,118.15,2Zm4.45,7.56c0,2.8-1.91,4.91-4.45,4.91s-4.48-2.13-4.48-5,1.91-4.91,4.44-4.91S122.6,6.73,122.6,9.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.21,6.92c0-2.89-2-4.69-5.22-4.69H38.76v14.6h2.7v-5h2.77l3.35,5h3.19l-3.72-5.48A4.34,4.34,0,0,0,50.21,6.92Zm-2.75.14c0,1.39-1,2.26-2.65,2.26H41.46V4.83h3.33C46.52,4.83,47.46,5.62,47.46,7.06Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.14,
    y: 2.23,
    width: 2.7,
    height: 14.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.14,8.24C90.49,7.58,90,7.11,90,6.12s.83-1.56,2.07-1.56A5.84,5.84,0,0,1,95.7,6l.13.1L97.28,4l-.1-.09A7.57,7.57,0,0,0,92.13,2C89.3,2,87.32,3.8,87.32,6.35,87.32,9.07,89,10,92,10.78c2.53.62,3,1.13,3,2.06s-.87,1.66-2.27,1.66a5.9,5.9,0,0,1-4.2-1.82l-.12-.11-1.63,2,.1.1A8.37,8.37,0,0,0,92.62,17c3,0,5-1.74,5-4.44C97.64,10.31,96.34,9.05,93.14,8.24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.92,8.24c-2.64-.66-3.11-1.13-3.11-2.12s.83-1.56,2.06-1.56A5.84,5.84,0,0,1,107.48,6l.13.1L109.07,4,109,3.86a7.57,7.57,0,0,0-5-1.83C101.08,2,99.1,3.8,99.1,6.35c0,2.72,1.71,3.69,4.66,4.43,2.53.62,3,1.13,3,2.06s-.87,1.66-2.26,1.66a5.89,5.89,0,0,1-4.2-1.82l-.12-.11-1.64,2,.11.1A8.37,8.37,0,0,0,104.4,17c3,0,5-1.74,5-4.44C109.42,10.31,108.12,9.05,104.92,8.24Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "137.05 2.23 137.05 11.8 130.02 2.29 129.98 2.23 127.52 2.23 127.52 16.83 130.19 16.83 130.19 6.98 137.43 16.77 137.48 16.83 139.71 16.83 139.71 2.23 137.05 2.23"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.23,21.77A5.72,5.72,0,0,1,21.17,16v0a5.79,5.79,0,0,1,6-5.8h2.66A16,16,0,0,0,0,10.39H4.11a4.94,4.94,0,0,1,3.63,1.2,3.48,3.48,0,0,1,1,2.6v0a3.53,3.53,0,0,1-2.3,3.44l2.66,3.89H5.54L3.29,18.17H1.92v3.38H0a16,16,0,0,0,30-.29A7.61,7.61,0,0,1,27.23,21.77ZM20,21.55H16.94V17.31H13v4.24H9.88V10.39H13v4.18h4V10.39H20Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.64,14.43v0c0-.89-.66-1.34-1.68-1.34h-2v2.7H4C5,15.75,5.64,15.24,5.64,14.43Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.14,17.29v1.36a3.11,3.11,0,0,1-1.78.46,3,3,0,0,1-3-3.11v0a2.91,2.91,0,0,1,2.85-3h3.44a14.51,14.51,0,0,1,.25,2.1H27v2.26Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.76,
    y: 19.98,
    width: 100.94,
    height: 0.39
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml",
    type: "text/css"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhgLogo);
export default __webpack_public_path__ + "static/media/rhg-logo.d1507ddaf6bff8bcfddbd67d496d5acb.svg";
export { ForwardRef as ReactComponent };